import { render, staticRenderFns } from "./NMBS1.vue?vue&type=template&id=6d4be269&"
import script from "./NMBS1.vue?vue&type=script&lang=js&"
export * from "./NMBS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports